module.exports = __webpack_public_path__ + "static/zoe-web-samsung@2x-edited-3d7ac52438ef5eac758cea200c7a1aa8.jpg";